export enum ImageSlotMessageType {
  Viewer = 'image-slot:viewer',
  Upload = 'image-slot:open',
}